import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'

export const useQuery = <T>() => {
  const location = useLocation<T>()
  const history = useHistory()
  const query: T = queryString.parse(location.search) as any
  return {
    search: query,
    set: (search: T, push?: boolean) => {
      const path = `${location.pathname}?${
        queryString.stringify(search as any) ?? ''
      }`
      push ? history.push(path) : history.replace(path)
    },
  }
}
